module.exports = __webpack_public_path__ + "img/a6.deb9196a.png";